import React from "react";
import UniversalForm from "../../../components/UniversalForm/UniversalForm";
import { usePipelineFormConfig, PipelineFormProps } from "../../../components/UniversalForm/entityForms";

const PipelineForm: React.FC<PipelineFormProps> = (props) => {
  const config = usePipelineFormConfig(props);
  return (
    <>
      <style>{`
        .pipeline-form-responsive {
          max-width: 615px;
          margin: 0 auto;
        }

        @media (min-width: 1024px) {
          .pipeline-form-responsive {
            max-width: 922px;
          }
        }
      `}</style>
      <div className="pipeline-form-responsive">
        <UniversalForm config={config} />
      </div>
    </>
  );
};

export default PipelineForm;
